import { GROUP_LABELS, GROUP_ORDER, ORDO_NODES } from "@/content/ordo";
import { Mono, TextLink } from "@/components/site/primitives";

const Field = ({ term, children }) => (
  <div>
    <dt><Mono>{term}</Mono></dt>
    <dd className="mt-1.5 text-[15px] leading-relaxed">{children}</dd>
  </div>
);

export const NodePanel = ({ node, onSelect }) => (
  <div data-testid="arch-panel">
    <Mono accent>{GROUP_LABELS[node.group]}</Mono>
    <h3 data-testid="arch-panel-title" className="mt-3 font-display text-2xl font-bold leading-tight sm:text-3xl">{node.label}</h3>
    <p className="mt-1 text-sm text-o-dim">{node.tagline}</p>
    <dl className="mt-6 space-y-5">
      <Field term="What it concerns">{node.concerns}</Field>
      <Field term="Why it matters">{node.matters}</Field>
      <Field term="How it relates">
        <span className="text-o-dim">{node.relationNote}</span>
        <span className="mt-3 flex flex-wrap gap-2">
          {node.relates.map((r) => (
            <button key={r} type="button" onClick={() => onSelect(r)} data-testid={`arch-related-${r}`}
              className="border border-o-line px-2.5 py-1 text-xs transition-colors hover:border-o-accent hover:text-o-accent">
              {ORDO_NODES[r].label}
            </button>
          ))}
        </span>
      </Field>
    </dl>
    <TextLink to={node.to} testid="arch-panel-explore" className="mt-7">{node.toLabel}</TextLink>
  </div>
);

export const ArchitectureText = () => (
  <div className="divide-y divide-o-line" id="architecture-text" data-testid="architecture-text">
    {GROUP_ORDER.map((g) => (
      <section key={g} className="grid gap-6 p-5 sm:p-8 lg:grid-cols-12">
        <h3 className="lg:col-span-3"><Mono accent>{GROUP_LABELS[g]}</Mono></h3>
        <div className="space-y-8 lg:col-span-9">
          {Object.values(ORDO_NODES).filter((n) => n.group === g).map((n) => (
            <article key={n.id}>
              <h4 className="font-display text-xl font-bold">{n.label} <span className="font-normal text-o-dim">· {n.tagline}</span></h4>
              <p className="mt-2 leading-relaxed">{n.concerns}</p>
              <p className="mt-2 leading-relaxed text-o-dim">{n.matters}</p>
              <p className="mt-2 text-sm text-o-dim">{n.relationNote}</p>
              <TextLink to={n.to} testid={`arch-text-link-${n.id}`} className="mt-3">{n.toLabel}</TextLink>
            </article>
          ))}
        </div>
      </section>
    ))}
  </div>
);
